// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { GetVocAutoMateTasksByTaskTypeParam, BaseResponseMapintobject } from '../../types';

/**
 * getTaskStatus
 *
 * @export
 * @tags voc自动化配置
 * @link [GET] /vocAutoMateTasks/{taskType}
 * @param taskType
 */
export function getVocAutoMateTasksByTaskType(
    options: ApiOptions<GetVocAutoMateTasksByTaskTypeParam, never> & {
        segments: GetVocAutoMateTasksByTaskTypeParam;
    }
): Promise<BaseResponseMapintobject> {
    return request<never, GetVocAutoMateTasksByTaskTypeParam, never>(
        '/vocAutoMateTasks/{taskType}',
        { ...options, method: 'get', __$requestCalleeName: 'getVocAutoMateTasksByTaskType' }
    );
}

export const meta = [
    { tags: ['voc自动化配置'], path: '/vocAutoMateTasks/{taskType}', method: 'get' },
];
